import SecureLS from "secure-ls";
var ls = new SecureLS({ encodingType: 'aes' });
import _ from "lodash";
import moment from "moment";
import Encoding from 'encoding-japanese';

export function getStatus() {
	const status = [
		{
			"value": "0",
			"text": "非アクティブ"
		},
		{
			"value": "1",
			"text": "アクティブ"
		}
	]
	return status
}

// 事業所グループのピン色プリセット。
// マップ上の既存マーカー（現在地=水色 blue-dot、拠点=黄色 #FFD700）と紛らわしい
// 青系・黄系は除外した、識別しやすい色のみを並べる。
export function getGroupPinColors() {
	return [
		"#E53935", // 赤
		"#FB8C00", // オレンジ
		"#43A047", // 緑
		"#8E24AA", // 紫
		"#EC407A", // ピンク
		"#6D4C41", // 茶
		"#5E35B1", // 深紫
		"#D81B60", // マゼンタ
		"#00897B", // ティール
		"#3949AB", // インディゴ
	]
}

// グループ未設定の事業所ピンの色（黒縁の白）。今回作成するマップ共通。
export const GROUP_UNASSIGNED_PIN_COLOR = "#FFFFFF";

export function userCategory() {
	const category = [
		// {
		// 	"value": null,
		// 	"text": "Please select",
		// 	// disabled: true
		// },
		{
			"value": "1",
			"text": "オーナー"
		},
		{
			"value": "2",
			"text": "オーナー施術家"
		},
		{
			"value": "3",
			"text": "施術家"
		},
		{
			"value": "4",
			"text": "スタッフ"
		},
		{
			"value": "5",
			"text": "本部"
		},
		{
			"value": "6",
			"text": "委託先"
		},
		{
			"value": "7",
			"text": "PT"
		}
	]
	return category
}

export function prefectures() {
	const prefecture = [
		{
			"value": "",
			"text": "",
		},
		{
			"value": "1",
			"text": "北海道"
		},
		{
			"value": "2",
			"text": "青森県"
		},
		{
			"value": "3",
			"text": "岩手県"
		},
		{
			"value": "4",
			"text": "宮城県"
		},
		{
			"value": "5",
			"text": "秋田県"
		},

		{
			"value": "6",
			"text": "山形県"
		},
		{
			"value": "7",
			"text": "福島県"
		},
		{
			"value": "8",
			"text": "茨城県"
		},
		{
			"value": "9",
			"text": "栃木県"
		},
		{
			"value": "10",
			"text": "群馬県"
		},
		{
			"value": "11",
			"text": "埼玉県"
		},
		{
			"value": "12",
			"text": "千葉県"
		},
		{
			"value": "13",
			"text": "東京都"
		},
		{
			"value": "14",
			"text": "神奈川県"
		},
		{
			"value": "15",
			"text": "新潟県"
		}, {
			"value": "16",
			"text": "富山県"
		},
		{
			"value": "17",
			"text": "石川県"
		},
		{
			"value": "18",
			"text": "福井県"
		},
		{
			"value": "19",
			"text": "山梨県"
		},
		{
			"value": "20",
			"text": "長野県"
		},
		{
			"value": "21",
			"text": "岐阜県"
		},
		{
			"value": "22",
			"text": "静岡県"
		},
		{
			"value": "23",
			"text": "愛知県"
		}, {
			"value": "24",
			"text": "三重県"
		},
		{
			"value": "25",
			"text": "滋賀県"
		},
		{
			"value": "26",
			"text": "京都府"
		},
		{
			"value": "27",
			"text": "大阪府"
		},
		{
			"value": "28",
			"text": "兵庫県"
		},
		{
			"value": "29",
			"text": "奈良県"
		},
		{
			"value": "30",
			"text": "和歌山県"
		},
		{
			"value": "31",
			"text": "鳥取県"
		},
		{
			"value": "32",
			"text": "島根県"
		},
		{
			"value": "33",
			"text": "岡山県"
		},
		{
			"value": "34",
			"text": "広島県"
		},
		{
			"value": "35",
			"text": "山口県"
		},
		{
			"value": "36",
			"text": "徳島県"
		},
		{
			"value": "37",
			"text": "香川県"
		},
		{
			"value": "38",
			"text": "愛媛県"
		},
		{
			"value": "39",
			"text": "高知県"
		},
		{
			"value": "40",
			"text": "福岡県"
		},
		{
			"value": "41",
			"text": "佐賀県"
		},
		{
			"value": "42",
			"text": "長崎県"
		},
		{
			"value": "43",
			"text": "熊本県"
		},
		{
			"value": "44",
			"text": "大分県"
		},
		{
			"value": "45",
			"text": "宮崎県"
		},
		{
			"value": "46",
			"text": "鹿児島県"
		},
		{
			"value": "47",
			"text": "沖縄県"
		},
	]
	return prefecture
}

export function roleAccess() {
	const role_access = [
		// {
		// 	"value": null,
		// 	"text": "Please select",
		// 	// disabled: true
		// },
		{
			"value": "1001",
			"text": "本部group1 : 本部"
		},
		{
			"value": "1002",
			"text": "施術家 : 委託先"
		},
		{
			"value": "1003",
			"text": "本部group2 : 本部"
		}
	]
	return role_access;
}

export function joinOptions() {
	const options = [
		{ item: 'OR', name: 'OR検索' },
		{ item: 'AND', name: 'AND検索' }
	];
	return options;
}

export const phoneRegex = /^[0-9-]*$/;
export const zipRegex = /^[0-9]{3}(?:-[0-9]{4})?$/;
export const onlyEnglishCharNum = /^[~`!@#$%^&*()_+=[\]{}|;':",./<>?a-zA-Z0-9-]+$/;
export const phoneHyphen = /^(?!-)(?!.*--)(?!.*-$)(?=.*-)(?!.*-.*-.*-)[\d-]+$/;   //min 1 hyphen to upto 2
// const decim = helpers.regex("decim", /^\d*(\.\d{0,2})?$/);
// const numberdecimal = helpers.regex("numberdecimal", /^[0-9]+(\.[0-9]{1,2})?$/);

export function checkKanaOnly(value) {
	//for kana and hiragana((/[^ぁ-んァ-ヶー\s]/);
	//only kana(/[^ァ-ヶー\s]/)
	if (((/[^ァ-ヶー\s]/).test(value) == true)) {
		//wrong input
		return false;
	} else {
		return true;
	}
}



export function getContratType() {
	const contract_type = [
		{
			"value": "0",
			"text": "個人"
		},
		{
			"value": "1",
			"text": "法人"
		}
	]
	return contract_type
}

export function getDistanceOptions() {
	const contract_type = [
		{
			"value": "1",
			"text": "1"
		},
		{
			"value": "2",
			"text": "2"
		},
		{
			"value": "3",
			"text": "3"
		},
		{
			"value": "4",
			"text": "4"
		},
		{
			"value": "5",
			"text": "5"
		},
		{
			"value": "6",
			"text": "6"
		},
		{
			"value": "7",
			"text": "7"
		},
		{
			"value": "8",
			"text": "8"
		},
		{
			"value": "9",
			"text": "9"
		},
		{
			"value": "10",
			"text": "10"
		},
		{
			"value": "11",
			"text": "11"
		},
		{
			"value": "12",
			"text": "12"
		},
		{
			"value": "13",
			"text": "13"
		},
		{
			"value": "14",
			"text": "14"
		},
		{
			"value": "15",
			"text": "15"
		},
		{
			"value": "16",
			"text": "16"
		},
	]
	return contract_type
}

export function getStateSimple() {
	const state_simple = [
		{
			"value": "契約中",
			"text": "契約中",
		},
		{
			"value": "解約申出",
			"text": "解約申出"
		},
		{
			"value": "契約終了",
			"text": "契約終了"
		}
	]
	return state_simple
}

export function getStateDetails() {
	const state_details = [
		{
			"value": "研修前",
			"text": "研修前"
		},
		{
			"value": "稼働中",
			"text": "稼働中"
		},
		{
			"value": "休止中",
			"text": "休止中"
		},
		{
			"value": "解約",
			"text": "解約"
		},
		{
			"value": "開業前CH",
			"text": "開業前CH"
		}
	]
	return state_details
}

export function getUserRegistrationManager() {
	const user_registration_manager = [
		{
			"value": "本部",
			"text": "本部"
		},
		{
			"value": "神戸レセプトセンター",
			"text": "神戸レセプトセンター"
		},
		{
			"value": "東京レセプトセンター",
			"text": "東京レセプトセンター"
		},
		{
			"value": "自店",
			"text": "自店"
		}
	]
	return user_registration_manager
}

export function getRoles() {
	const roles = [
		// {
		// 	"value": null,
		// 	"text": "Please select",
		// },
		{
			"value": "1",
			"text": "管理者"
		},
		{
			"value": "2",
			"text": "委託先"
		},
		{
			"value": "3",
			"text": "オーナー"
		},
		{
			"value": "4",
			"text": "基幹店スタッフ"
		},
		{
			"value": "5",
			"text": "拠点スタッフ"
		},
		{
			"value": "6",
			"text": "基幹店_セ"
		},
		{
			"value": "7",
			"text": "所属_セ"
		},
		{
			"value": "8",
			"text": "セ"
		},
		{
			"value": "9",
			"text": "委託_セ"
		},
		{
			"value": "10",
			"text": "施設職員"
		},
		{
			"value": "11",
			"text": "本部"
		}
	]
	return roles;
}

export function getLeafletInstallition() {
	const leaflet_installition = [
		{
			'text': "有",
			'value': "有"
		},
		{
			'text': "無",
			'value': "無"
		}
	];

	return leaflet_installition;
}

export function toggleActiveClass(addRemoveClass, className) {
	const element = document.getElementsByClassName(className)[0];
	if (element != undefined) {
		if (addRemoveClass === "addClass") {
			element.parentElement.classList.add("active");
		} else {
			element.parentElement.classList.remove("active");
		}
	}

}

export function readACL(menuID) {
	let screens = ls.get("screen_permissions")
	const foundAccess = _.find(JSON.parse(screens), function (o) {
		return (o.screen_code === menuID && o.select != 0);
	});
	return foundAccess;
}

export function checkCreateButtonPermission(menuID) {
	let screens = ls.get("screen_permissions")
	const access = JSON.parse(screens).some(function (object) {
		return object.screen_code === menuID && object.insert != 0;
	});
	return access;
}

export function checkDeleteButtonPermission(menuID) {
	let screens = ls.get("screen_permissions")
	const access = JSON.parse(screens).some(function (object) {
		return object.screen_code === menuID && object.delete != 0;
	});
	return access;
}

export function checkUpdateButtonPermission(menuID) {
	let screens = ls.get("screen_permissions")
	const access = JSON.parse(screens).some(function (object) {
		return object.screen_code === menuID && object.update != 0;
	});
	return access;
}

export function checkExportButtonPermission(menuID) {
	let screens = ls.get("screen_permissions")
	const access = JSON.parse(screens).some(function (object) {
		// リリース前のログインで export キーを持たないキャッシュが残っている場合があるため、
		// undefined は「権限なし」に倒す（Number(undefined) は NaN となり false になる）
		return object.screen_code === menuID && Number(object.export) > 0;
	});
	return access;
}

export function getAttachmentLists() {
	const attachmentLists = [
		{
			file_attachment_type: "1",
			attached: "保険証（マイナ保険証）",
			attachments: "",
			comment: "",
			attachment_datetime: "",
			registered_person: "",
			headquarter_comment: "",
			headquarter_comment_datetime: "",
			head_office_registrant: "",
			background: "table_light_green",
		},
		{
			file_attachment_type: "2",
			attached: "高齢受給者証",
			attachments: "",
			comment: "",
			attachment_datetime: "",
			registered_person: "",
			headquarter_comment: "",
			headquarter_comment_datetime: "",
			head_office_registrant: "",
			background: "table_light_green",
		},
		{
			file_attachment_type: "3",
			attached: "医療助成1",
			attachments: "",
			comment: "",
			attachment_datetime: "",
			registered_person: "",
			headquarter_comment: "",
			headquarter_comment_datetime: "",
			head_office_registrant: "",
			background: "table_light_blue",
		},
		{
			file_attachment_type: "4",
			attached: "医療助成2",
			attachments: "",
			comment: "",
			attachment_datetime: "",
			registered_person: "",
			headquarter_comment: "",
			headquarter_comment_datetime: "",
			head_office_registrant: "",
			background: "table_light_blue",
		},
		{
			file_attachment_type: "5",
			attached: "その他1",
			attachments: "",
			comment: "",
			attachment_datetime: "",
			registered_person: "",
			headquarter_comment: "",
			headquarter_comment_datetime: "",
			head_office_registrant: "",
			background: "table_light_cream",
		},
		{
			file_attachment_type: "6",
			attached: "その他2",
			attachments: "",
			comment: "",
			attachment_datetime: "",
			registered_person: "",
			headquarter_comment: "",
			headquarter_comment_datetime: "",
			head_office_registrant: "",
			background: "table_light_cream",
		},
		{
			file_attachment_type: "7",
			attached: "その他3",
			attachments: "",
			comment: "",
			attachment_datetime: "",
			registered_person: "",
			headquarter_comment: "",
			headquarter_comment_datetime: "",
			head_office_registrant: "",
			background: "table_light_cream",
		},
		{
			file_attachment_type: "8",
			attached: "要否意見書",
			attachments: "",
			comment: "",
			attachment_datetime: "",
			registered_person: "",
			headquarter_comment: "",
			headquarter_comment_datetime: "",
			head_office_registrant: "",
			background: "table_light_grey",
		},
		{
			file_attachment_type: "9",
			attached: "同意書",
			attachments: "",
			comment: "",
			attachment_datetime: "",
			registered_person: "",
			headquarter_comment: "",
			headquarter_comment_datetime: "",
			head_office_registrant: "",
			background: "table_light_grey",
		},
	];
	return attachmentLists;
}

export function registrationDivision() {
	const registrationDivision = [
		{
			"value": "1",
			"text": "仮登録"
		},
		{
			"value": "2",
			"text": "本部送信"
		},
		{
			"value": "3",
			"text": "差戻し"
		},
		{
			"value": "4",
			"text": "本登録"
		}
	]
	return registrationDivision
}

export function practitionerCategory() {
	const category = [
		{
			"value": "1",
			"text": "オーナー"
		},
		{
			"value": "2",
			"text": "基幹店スタッフ"
		},
		{
			"value": "3",
			"text": "拠点スタッフ"
		},
		{
			"value": "4",
			"text": "基幹店_セ"
		},
		{
			"value": "5",
			"text": "_セ"
		},
		{
			"value": "6",
			"text": "セ"
		},
		{
			"value": "7",
			"text": "委託_セ"
		}
	]
	return category
}

/*
 * Method which accepts only numeric values
 */
export function onlyNumber($event) {
	let keyCode = $event.keyCode ? $event.keyCode : $event.which;
	if ((keyCode < 48 || keyCode > 57) && keyCode !== 46 && keyCode !== 45) {
		$event.preventDefault();
	}
}
export function onlyNumberWithOutDot($event) {
	let keyCode = $event.keyCode ? $event.keyCode : $event.which;
	if ((keyCode < 48 || keyCode > 57)) {
		$event.preventDefault();
	}
}
// alphanumeric characters regex
export const loginIdRegex = /^[a-zA-Z0-9]*$/;

export function downloadImportCsv(items, fileName) {
	let csv = "";
	items.forEach(function (it) {
		csv += Object.keys(it).map(function (item) {
			let value = it[item] ?? '';
			value = value.toString().replace(/"/g, '""');
			if (value.search(/("|,|\n|\r)/g) >= 0) {
				value = `"${value}"`;
			}
			return value;
		}).join(',') + "\n";
	}.bind(csv))

	// csv = new Encoding.stringToCode(csv.toString());
	// csv = Encoding.convert(csv, 'SJIS');
	// csv = new Uint8Array(csv);
	// Add BOM to CSV string
	const bom = '\uFEFF';
	const csvWithBom = bom + csv;

	// Encode to UTF-8 with BOM
	const utf8encoder = new TextEncoder();
	const csvEncoded = utf8encoder.encode(csvWithBom);

	if (window.navigator.msSaveOrOpenBlob) {
		// For IE, Edge
		// const blob = new Blob([csv], { "type": "text/csv" });
		const blob = new Blob([csvEncoded], { type: "text/csv;charset=utf-8;" });
		window.navigator.msSaveOrOpenBlob(blob, fileName);
	} else {
		// For modern browsers
		// const url = URL.createObjectURL(new Blob([csv], { type: 'text/csv' }));
		const blob = new Blob([csvEncoded], { type: 'text/csv;charset=utf-8;' });
		const url = URL.createObjectURL(blob);
		const linkEl = document.createElement('a');
		linkEl.href = url;
		linkEl.setAttribute('download', fileName);
		document.body.appendChild(linkEl);
		linkEl.click();
		URL.revokeObjectURL(url);
		linkEl.parentNode.removeChild(linkEl);
	}

}
export const ahakiNumberRegex = /^[0-9-]*$/;

//decimal
export const decimal = /^\d+(\.\d+)?$/;

export const singleDecimal = /^\d+(\.\d{1})?$/;



